import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './firebase';

let app;
if (!app) {
  app = createApp(App)
    .use(store)
    .use(router)
    .mount('#app');
}
